/**
 * 系统主要配置(入口文件)
 **/
import Vue from "vue";
import App from "./App.vue";
import store from "./components/store";
import router from "./components/router/index";
import iView from "iview";
import "iview/dist/styles/iview.css";
import "element-ui/lib/theme-chalk/index.css";

import "swiper/dist/css/swiper.css";

import { track } from "./api/goods";
import moment from "moment";

let NodeRSA = require("node-rsa");
Vue.prototype.$nodersa = NodeRSA;

import layer from "layui-layer";

// rsa加密
import Rsa from "utils/rsa.js";

import BaiduMap from "vue-baidu-map";
//图片放大控件
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
Vue.use(iView);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});

//百度地图
Vue.use(BaiduMap, {
  ak: "8XnlHluVeE2mGTHf96WGP9jRf9Dr02un",
});

//设置提示框位置
Vue.prototype.$Message.config({
  top: 300,
  duration: 2,
});

Vue.prototype.$Rsa = Rsa; // 将Rsa注册为公共方法,方便其他页面调用

Vue.directive("tracking", {
  inserted(el, binding, vnode) {
    el.addEventListener("click", () => {
      track(binding.value);
    });
  },
});

let startTime = Date.now();
let currentTime;
let userBehaviorsLogDTOList = localStorage.getItem("userBehaviorsLogDTOList")
  ? JSON.parse(localStorage.getItem("userBehaviorsLogDTOList"))
  : [];

// 权限判断--黑名单 高春超
router.beforeEach((to, from, next) => {
  if (iView.Modal) iView.Modal.remove();
  if (to) {
    // 离开界面
    // 第一步：页面跳转后记录一下当前的时间 currentTime
    currentTime = Date.now();
    // from.matched.forEach((routeItem) => {
    //   pageName.push(routeItem.meta.title);
    // });
    console.log(startTime, "to-------------");
    let obj = {
      operationObject: 3,
      operationPage: from.meta.title,
      operationStatus: 1,
      operationType: 2,
      username: localStorage.getItem("userName"),
      operationLocation: 1,
      operationApi: "",
      deviceType: 1,
      deviceSystem: 1,
      failureReason: "",
      browser: window.navigator.appCodeName,
      deviceVersion: window.navigator.platform,
      startTime: new moment(startTime).format("YYYY-MM-DD HH:mm:ss"),
      endTime: new moment(currentTime).format("YYYY-MM-DD HH:mm:ss"),
    };
    userBehaviorsLogDTOList.push(obj);
    localStorage.setItem(
      "userBehaviorsLogDTOList",
      JSON.stringify(userBehaviorsLogDTOList)
    );
    if (userBehaviorsLogDTOList.length > 9) {
      let data = {
        userBehaviorsLogDTOList: userBehaviorsLogDTOList,
      };
      track(data).then((res) => {
        localStorage.removeItem("userBehaviorsLogDTOList");
      });
    }

    // 第三步：每次都要初始化一下 startTime
    startTime = Date.now();
  }

  iView.LoadingBar.start();
  if (to.meta.auth && store.getters.sid.length === 0) {
    // 在登录黑名单，全部重定向到登录页
    next({
      path: "/login",
      query: from.query,
    });
  } else {
    next(); // 直接进入
  }
  if (sessionStorage.getItem("sid") == null && to.path.search("/user") == 0) {
    next({
      path: "/login",
      query: from.query,
    });
  }
});
router.afterEach((route) => {
  iView.LoadingBar.finish();
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js